import * as AmazonAuthorAA from 'sdk/AA';
import S3 from 'sdk/S3';
import EelMetricsApi from 'sdk/EelMetrics';

const AA = AmazonAuthorAA;
const {
  Assets,
  Functions,
  Method,
  Resource,
} = AA;
const Metrics = EelMetricsApi;

export {
  AA, Assets, Functions, Method, Resource, S3, Metrics,
};
